/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * UserAddDTO.ts
 */

import {Type} from "../../../tools/view/form/FormInput";
import Translation from "../../../services/translation/Translation";
import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import User from "../../User";
import {UserClientDTO} from "../../dto/user/UserClientDTO";
import {SelectField} from "../../../tools/model/form/SelectField";
import {Selectable} from "../../../tools/model/form/Selectable";
import Client from "../../Client";

export default class UserClientForm extends AbstractForm<UserClientDTO> {
    constructor(user: User, clients: Client[]) {
        super();

        let selectableValues: Array<Selectable<string>> = clients.map(client => {
            return {value: client.id, name: client.name, disabled: false};
        })

        this.fields.set(UserClientDTO.CLIENT_IDS, new SelectField(
            selectableValues,
            UserClientDTO.CLIENT_IDS,
            (t: Translation) => t.clients,
            () => true,
            Type.SELECT,
            true,
            true,
            [],
            []
        ));

        this.load(UserClientDTO.fromUser(user));
    }
}
